import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

import Dark from '../views/Dark'
import HomeTwo from '../views/HomeTwo'
import HomeThree from '../views/HomeThree'
import Contact from '../views/Contact.vue'
import About from '../views/About.vue'
import Archive from '../views/Archive.vue'
import fourOfour from '../components/404.vue'
import PostOne from '../components/Posts/PostOne/index.vue'
import PostTwo from '../components/Posts/PostTwo/index.vue'
import PostThree from '../components/Posts/PostThree/index'
import Entertainment from '../components/category/Entertainment.vue'
import Features from '../components/category/Feature.vue'
import Sports from '../components/category/Sports.vue'
import Trending from '../components/category/Trending.vue'
import Profile from '../components/Profile/index.vue'
import initPwd from '../components/Profile/InitPwd.vue'
import Login from '../views/Login.vue'
import ResetPwd from '../components/Profile/ResetPwd.vue'
import Register from '../views/Register.vue'
import RegResult from '../views/RegResult.vue'
import Manuscript from '../views/Manuscript.vue'
import ManResult from '../views/ManResult.vue'
import Traffic from '../views/Traffic.vue'
import Schedule from '../views/Schedule.vue'
import ScheduleSub from '../views/ScheduleSub.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dark',
    name: 'Dark',
    component: Dark
  },
  {
    path: '/home-two',
    name: 'HomeTwo',
    component: HomeTwo
  },
  {
    path: '/home-three',
    name: 'HomeThree',
    component: HomeThree
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/about-us',
    name: 'About',
    component: About
  },
  {
    path: '/archive',
    name: 'Archive',
    component: Archive
  },
  {
    path: '/404',
    name: '404',
    component: fourOfour
  },
  {
    path: '/posts/postOne',
    name: 'PostOne',
    component: PostOne
  },
  {
    path: '/posts/posttwo',
    name: 'PostTwo',
    component: PostTwo
  },
  {
    path: '/posts/postthree',
    name: 'PostThree',
    component: PostThree
  },
  {
    path: '/entertainment',
    name: 'Entertainment',
    component: Entertainment
  },
  {
    path: '/features',
    name: 'Features',
    component: Features
  },
  {
    path: '/sports',
    name: 'Sports',
    component: Sports
  },
  {
    path: '/trending',
    name: 'Trending',
    component: Trending
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/initpwd',
    name: 'InitPwd',
    component: initPwd
  },
  {
    path: '/resetpwd',
    name: 'ResetPwd',
    component: ResetPwd
  },
  {
    path: '/register/form',
    name: 'Register',
    component: Register,
    meta: {
      menuKey: 'menu.register'  // 关联菜单 key
    }
  },
  {
    path: '/register/result',
    name: 'RegResult',
    component: RegResult
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/manuscript/form',
    name: 'Manuscript',
    component: Manuscript,
    meta: {
      menuKey: 'menu.manuscript'  // 关联菜单 key
    }
  },
  {
    path: '/manuscript/result',
    name: 'ManuscriptResult',
    component: ManResult
  },
  {
    path: '/traffic',
    name: 'Traffic',
    component: Traffic
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule
  },
  {
    path: '/schedule/sub',
    name: 'ScheduleSub',
    component: ScheduleSub
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 🔥 如果有 savedPosition（浏览器前进/后退），恢复位置
    if (savedPosition) {
      return savedPosition;
    }
    
    // 🔥 如果有 hash（锚点跳转），延迟处理，让 Home.vue 的 scrollToTarget 接管
    if (to.hash) {
      // 不执行任何滚动，交给 Home.vue 处理
      return false;
    }
    
    // 🔥 普通路由跳转（无 hash），滚动到顶部
    return { x: 0, y: 0 };
  }
});

export default router
